var map = {
	"./chart-area.svg": "3dcd",
	"./chart-bar.svg": "2ee3",
	"./chart-column.svg": "7733",
	"./chart-donut.svg": "b571",
	"./chart-gauge.svg": "40be",
	"./chart-line.svg": "ac85",
	"./chart-pie.svg": "3b08",
	"./chart-radar.svg": "2312"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";